
import { Settings, ContentPaste, RequestQuoteOutlined, FolderOpenOutlined, ImageOutlined, PeopleAltOutlined, DriveEta, StoreOutlined, Inventory2Outlined, EmojiTransportation, PowerSettingsNew, SaveAs, SettingsSuggest, AdminPanelSettings, EmojiEvents, Home, PictureAsPdf, Plagiarism, RollerSkating, Comment, ArrowCircleLeft, AddCircle, FormatListNumbered, Add, ArrowBack, Groups, Paid, Store, RotateLeft, PlayCircleFilled, ExpandMore, SupervisedUserCircle, Delete, ImageSearchRounded, VideoCameraBack, GroupAdd, DoDisturb, CheckCircleOutline, Pin, Stop, Timer, Login, AccountCircle, Menu, ArrowBackIosNew, Notifications, Search, Email, Lock, ContentPasteSearch, AspectRatio, Wc, ManageHistory, Dashboard, Addchart, CalendarMonth, Close, ExitToApp, FactCheck, DisabledByDefault, CheckBox, ManageAccounts, Straight, AccountTree, AccountTreeOutlined, YouTube, DownloadForOffline, HubOutlined, Visibility, VisibilityOff, VideoCameraFront, QueryStats, KeyboardArrowUp, KeyboardArrowDown, Merge, NoteAddOutlined, FilterAlt, RequestQuote, QrCodeScanner, RememberMe, QrCode2, Casino, InsertPhoto, KeyboardArrowRight, AirportShuttle, Warehouse, Category, Info, HolidayVillage, Widgets, StackedBarChart, Pets, ErrorOutline, Assignment, MultipleStop, TrendingDown, ManageSearch, HighlightOff, CalendarToday, TrendingUp, BarChart, AddBusiness, MenuOpen, CloudUpload } from '@mui/icons-material';




export const iconos = {
    // grupo: <Diversity3 />,
    abajo: <KeyboardArrowUp />,
    add_circle: <AddCircle />,
    arbol: <AccountTree />,
    arriba: <KeyboardArrowDown />,
    back_circle: <ArrowCircleLeft />,
    back: <ArrowBack />,
    bien: <CheckBox/>,
    buscar: <Search />,
    calendario: <CalendarMonth />,
    camara: <VideoCameraBack />,
    carnet: <RememberMe />,
    cerrada:  <DoDisturb />,
    cerrar: <Close />,
    club: <Store/>,
    competencia: <EmojiEvents />,
    consultar: <ContentPasteSearch />,
    correo: <Email />,
    dashboard: <Dashboard />,
    usuarios: <SupervisedUserCircle />,
    derecha: <KeyboardArrowRight />,
    descargar: <DownloadForOffline />,
    distancia: <Straight />,
    drive: <DriveEta />,
    edad: <ManageHistory />,
    eliminar: <Delete />,
    emoji: <EmojiTransportation />,
    escalafon: <QueryStats />,
    estadistica: <Addchart />,
    existencia: <ContentPaste />,
    expandir: <ExpandMore />,
    fase: <RotateLeft/>,
    fechaesconder: <ArrowBackIosNew />,
    filtro: <FilterAlt />,
    folder: <FolderOpenOutlined />,
    fulltime: <VideoCameraFront />,
    genero: <Wc />,
    home: <Home />,
    imagen: <ImageOutlined />,
    iniciar: <PlayCircleFilled/>,
    inscripcion: <Comment />,
    inscripciones:  <GroupAdd />,
    inventory: <Inventory2Outlined />,
    listado: <FactCheck/>, 
    login: <Login />,
    logout: <PowerSettingsNew />,
    mal: <DisabledByDefault/>,
    menu: <FormatListNumbered />,
    merge: <Merge />,
    nota: <NoteAddOutlined />,
    notaPago: <RequestQuote/>,   
    notificacion: <Notifications />,
    novisualizar: <VisibilityOff />,
    numeracion:  <Pin />,
    pago: <Paid />,
    pantalla: <AspectRatio />,
    password: <Lock />,
    patin: <RollerSkating />,
    pdf: <PictureAsPdf />,
    people: <PeopleAltOutlined />,
    photo: <InsertPhoto />,
    plus: <Add />,
    precio: <RequestQuoteOutlined />,
    principal: <Menu />,
    profile: <ManageAccounts/>,
    puntos: <HubOutlined />,
    qr: <QrCodeScanner />,
    qr2: <QrCode2 />,
    salir: <ExitToApp />,
    save: <SaveAs />,
    setting: <Settings />,
    setting2: <SettingsSuggest />,
    sistema: <AdminPanelSettings />,
    sorteo: <Casino />,
    stop: <Stop/>,
    store: <StoreOutlined />,
    subirimg: <CloudUpload />,
    terminada:  <CheckCircleOutline />,
    tiempo: <Timer />,
    tree: <AccountTreeOutlined />,
    user: <AccountCircle />,
    usuarios: <Groups />,
    vahiculo: <AirportShuttle />,
    ver: <Plagiarism />,
    verimg: <ImageSearchRounded />,
    visualizar: <Visibility />,
    youtube: <YouTube />,
    granja: <Warehouse />,
    categoria: <Category />,
    info: <Info />,
    galpon: <HolidayVillage />,
    lote: <Widgets />,
    consumo: <StackedBarChart />,
    sexo: <Pets />,
    faltante: <ErrorOutline />,
    documento: <Assignment />,
    traslado: <MultipleStop />,
    merma: <TrendingDown />,
    historial: <ManageSearch />,
    cerrar: <HighlightOff />,
    calendario: <CalendarToday />,
    indicador: <TrendingUp />,
    chart: <BarChart />,
    stock: <AddBusiness />,
    entradas: <MenuOpen />,
    
};